import { useContext, useState } from "react";
import STMemberUpdateNicknameAndAvatar from "../../assets/styles/organisms/memberUpdateNicknameAndAvatar.module.scss";
import AccountIcon from "../atoms/icons/AccountIcon";
import { LoginUserContext } from "../../providers/LoginUserProvider";
import type { TAppMember } from "../../types/TAppMember";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import EditNicknameAvatar from "./EditNicknameAvatar";
import { getDisplayNickname } from "./getDisplayNickname";
import MessageBoardNickname from "../atoms/MessageBoardNickname";

const MemberUpdateNicknameAndAvatar = () => {
  const currentUser = useContext(LoginUserContext);
  const { member = {}, setMember } = currentUser ?? {};
  const {
    nickname = "",
    avatar_url = "",
    name = "",
    uid,
  } = member as TAppMember;
  const displayName = getDisplayNickname(nickname, name);
  const [isOpenEditDialog, setIsOpenEditDialog] = useState<boolean>(false);
  const onOpenEditDialog = () => {
    setIsOpenEditDialog(true);
  };
  const onEditDialogClose = () => {
    setIsOpenEditDialog(false);
  };
  return (
    <>
      <div className={STMemberUpdateNicknameAndAvatar.member_information}>
        {avatar_url ? (
          <img src={avatar_url} alt="avatar_url" />
        ) : (
          <AccountIcon />
        )}
        <div
          className={STMemberUpdateNicknameAndAvatar.member_nickname}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onOpenEditDialog();
          }}
        >
          <MessageBoardNickname
            nickname={displayName}
            className={STMemberUpdateNicknameAndAvatar.member_nickname}
          />
          <EditOutlinedIcon style={{ cursor: "pointer" }} fontSize="inherit" />
        </div>
      </div>
      {isOpenEditDialog && (
        <EditNicknameAvatar
          nickname={nickname ?? ""}
          avatar_url={avatar_url ?? ""}
          onClose={onEditDialogClose}
          onSuccess={({ nickname, avatar_url, name, avatarType }) => {
            setMember((prev) => {
              if (!prev) return prev;
              return {
                ...prev,
                nickname,
                avatar_url,
                name,
                avatarType,
              };
            });
          }}
        />
      )}
    </>
  );
};

export default MemberUpdateNicknameAndAvatar;
